<template>
    <div class="printContainerMulti transparent" style="position: relative">
        <div v-if="bewerb">
            <div v-if="Object.keys(this.bewerb?.settings.tabs).length<=1" class="druckBereich pageBreak">
                <meisterschaft-print-header :lv-id="bewerb?.settings.lvId">
                    <meisterschaft-print-bewerb-name :bewerb="bewerb"/>
                </meisterschaft-print-header>
                <div v-if="bewerb.getInfoText()" style="font-size: 16px; border-bottom: solid 1px #ddd; padding: 4px">
                    {{bewerb.getInfoText()}}</div>
                <meisterschaft-print-runde-tab :runde="bewerb.runden[10]" :bewerb="bewerb" class="mt-4"/>
            </div>
            <meisterschaft-print-runden v-else :bewerb="bewerb"/>
        </div>
    <!-- navigation box -->
        <div style="position: fixed; width: 26cm; top: 0; left: 0; height: 300px; right: 0; margin: auto">
            <v-btn fab dark bottom right color="primary" @click="openPrint()"
                   style="position: absolute; right: 90px; top: 15px; z-index: 15">
                <v-icon >mdi-printer</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>

import MeisterschaftPrintHeader from "@/views/ergebnisdienst/meisterschaft/print/meisterschaftPrintHeader.vue";
import MeisterschaftPrintRundeTab from "@/views/ergebnisdienst/meisterschaft/print/meisterschaftPrintRundeTab.vue";
import MeisterschaftPrintBewerbName from "@/views/ergebnisdienst/meisterschaft/print/meisterschaftPrintBewerbName.vue";
import FirebaseRead from "@/services/database/firebaseRead";
import {Bewerb} from "@/services/data/meisterschaften/bewerb";
import MeisterschaftPrintRunden from "@/views/ergebnisdienst/meisterschaft/print/meisterschaftPrintRunden.vue";

export default {
    name: "meisterschaftPrint",
    components: {
        MeisterschaftPrintRunden,
        MeisterschaftPrintBewerbName, MeisterschaftPrintRundeTab, MeisterschaftPrintHeader},
    computed: {
        bewerbId(){ return this.$route.query.id },
    },
    data: () => ({
        bewerb: null,
    }),
    created(){
        this.initBewerb();
    },
    methods: {
        async initBewerb(){
            const bewerb = await FirebaseRead.readSingleDoc('meisterschaftenBewerbe', this.bewerbId)
            this.bewerb = new Bewerb(bewerb)
        },
        openPrint(){
            window.print()
        }
    },
}
</script>

<style scoped>
    @media print{@page {size: portrait; margin: 0}}
    /*https://codepen.io/rafaelcastrocouto/pen/LFAes*/
    .druckBereich {
        width: 18cm; margin: auto;
    }
    .pageBreak {
        page-break-after: always;
        margin-top: 1.5cm
    }
    .printContainerMulti { position: relative; width: 100%;
        z-index: 20; overflow: auto;
        /*font-family: verdana, arial, helvetica;*/
    }
</style>